import {
  LIVE_CHECKIN_MAX_AGE_ALLOWED_HOURS,
  type LiveCheckinMaxAgeHours,
} from "../data/live-checkin-max-age";

/** Platform cockpit chips for the account Command Live Recent check-ins window. */
export function LiveCheckinMaxAgePicker({
  liveCheckinMaxAgeHours: hours,
  onChange,
}: {
  liveCheckinMaxAgeHours: LiveCheckinMaxAgeHours;
  onChange: (hours: LiveCheckinMaxAgeHours) => void;
}) {
  return (
    <fieldset className="tpl__fieldset ping-interval">
      <legend className="tpl__legend">Live check-ins window</legend>
      <p className="setup__field-hint">
        How far back Command Live paints Recent check-in dots. Older captures stay in Activity and
        Replay.
      </p>
      <div className="shift-duration__presets" role="group" aria-label="Live check-ins window options">
        {LIVE_CHECKIN_MAX_AGE_ALLOWED_HOURS.map((optionHours) => (
          <button
            key={optionHours}
            type="button"
            className={`toggle-chip${hours === optionHours ? " toggle-chip--on" : ""}`}
            aria-pressed={hours === optionHours}
            onClick={() => onChange(optionHours)}
          >
            {optionHours}h
          </button>
        ))}
      </div>
    </fieldset>
  );
}
